const generalInformation = {
	companyName: 'Skopei',
	skopeiSupportEmail: 'support@skopei.com',
	infoTopologyEmail: 'info@topology.nl',
	phoneNumber: '+31850046400',
} as const;

export default generalInformation;
